import { applyVAT } from '../../utils/string';

const viewAnalytics = (price, product, setup, currentPath, sku) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	window.dataLayer.push({
		event: 'ViewContent',
		values: {
			value: applyVAT(setup, price, false, 5),
			currency: setup.currency,
			content_name: product.title,
			content_type: 'product_group',
			content_ids: [`${product.id.slice(product.id.lastIndexOf('/') + 1)}`],
		},
	});
	window.dataLayer.push({
		event: 'ViewContentGA',
		ecommerce: {
			detail: {
				products: [{
					name: product.title,
					id: sku,
					sku,
					price: applyVAT(setup, price, false, 5),
					brand: product.vendor,
					category: currentPath.slice(0, currentPath.lastIndexOf('/')),
					variant: product.variants.filter((v) => v.selectedOptions?.color).reduce((acc, v) => (!acc ? v.selectedOptions.color : acc), ''),
				}],
			},
		},
	});
	const itemCategory = currentPath.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
	window.dataLayer.push({
		event: 'view_item',
		ecommerce: {
			items: [{
				item_name: product.title,
				item_id: `${product.id.slice(product.id.lastIndexOf('/') + 1)}`,
				price: applyVAT(setup, price, false, 5),
				item_brand: product.vendor,
				...itemCategory,
				quantity: '1',
			}],
		},
	});
};

export default viewAnalytics;
